export default "__VITE_ASSET__DhI2RXHR__"